import { userConstants } from '../constants/user.constants.js';
import { userService } from "../services/user.service";
import {
  loy3AppLoginUrl,
  loy3LoadProfileDataUrl,
  loy3LoginUrl,
  registrationInfo,
  resendEmailUrl,
  loy3AppLoginAsUser,
} from "../api/urls";
import { SET_MODAL } from "../constants";
import { getQueryString } from '../api';

/**
 * Actions exported
 */
export const userActions = {
  ssoLogin,
  loy3Login,
  loy3AppLogin,
  loadProfileData,
  storeUser,
  logout,
  getRegistrationInfo,
  resendEmail,
  handleResponse,
  loginWithToken,
  setInitialModalVisible,
};

function ssoLogin() {
  return dispatch => {
    dispatch(request());
    userService.login().then(
      authResponse => {
        dispatch(success(authResponse));
      },
      error => {
        dispatch(failure(error.toString()));
      });
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user }
  }

  function success(authResponse) {
    return { type: userConstants.LOGIN_SUCCESS, authResponse }
  }

  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error }
  }
}

function storeUser(userProfile) {
  return dispatch => {
    localStorage.setItem('_keycloakUser', JSON.stringify(userProfile));
    dispatch({ type: userConstants.STORE_USER, userProfile });
  }
}

function logout() {
  return async (dispatch) => {
    try {
      await userService.logout();
    } finally {
      dispatch({ type: userConstants.LOGOUT });
    }

  }
}

function loginWithToken(token, brandId, history) {
  return (dispatch) => {
    const url = `${loy3AppLoginAsUser}?token=${token}&brandId=${brandId}`;
    return fetch(url, { method: 'post' })
      .then((response) => response.ok ? response.json() : null)
      .then((jsonResponse) => {
        if (jsonResponse && jsonResponse.error === 0) {
          localStorage.setItem('_loy3User', JSON.stringify(jsonResponse.responseObj));
          dispatch(success(jsonResponse.responseObj));
          history.push('/profile');
          window.location.reload();
          return { success: true, authToken: jsonResponse.responseObj.token };
        }
        return { success: false, authToken: null };
      });
  };
  function success(response) {
    return { type: userConstants.LOY3_LOGIN_SUCCESS, authResponse: response }
  }
}

function loy3Login(username, password, brandId, locale) {
  const formData = new FormData();
  formData.append('username', btoa(username));
  formData.append('password', btoa(password));
  formData.append('brandId', brandId || '1');
  formData.append('locale', locale?.toLowerCase() || 'en');
  return dispatch => {
    return fetch(loy3LoginUrl, {
      method: 'POST',
      body: formData
    }).then(v => v.json())
      .then(r => {
        if (r.error === 0) {
          localStorage.setItem('_loy3User', JSON.stringify(r.responseObj));
          dispatch(success(r.responseObj));
          return { success: true, authToken: r.responseObj.token };
        }

        // Backend may return distinct types; LoginForm maps credential failures to a generic
        // message (option B). Status-specific UX (pending / blocked) still uses errorType/status.
        let failureError;
        let errorType = '';
        if (r.status === 500) {
          errorType = 'password';
          failureError = {
            message: 'Password error',
            type: 'password',
          };
        } else {
          const responseObj = r.responseObj || {};
          errorType = responseObj.type || responseObj.errorType || '';
          failureError = {
            type: errorType || 'loginFailed',
            message: r.message,
            id: responseObj.loyaltyMemberId
          };
          if (!errorType) {
            errorType = 'loginFailed';
          }
        }

        dispatch(failure(failureError));

        // accountNotActivated is handled inline in LoginForm (message + resend CTA).
        if (errorType === 'reCreatePassword') {
          dispatch({
            type: SET_MODAL,
            key: 'verifyAccount',
            val: true
          });
        }
        return { success: false, authToken: null, errorType };
      }).catch(err => {
        dispatch(failure(err.message));
        return { success: false, authToken: null };
      });
  };

  function success(response) {
    return { type: userConstants.LOY3_LOGIN_SUCCESS, authResponse: response }
  }

  function failure(error) {
    return { type: userConstants.LOY3_LOGIN_FAILURE, payload: error }
  }
}

function loy3AppLogin(username, brandId, successCallback, failureCallback) {
  const formData = new FormData();
  formData.append('user-id', btoa(username));
  formData.append('brandId', brandId || '1');
  formData.append('client-secret', 'cGFzc3dvcmQ=');
  formData.append('client-id', 'ZTFiNTUyMWEtMjViNC00ZDFlLWJmYmUtMTIyNDk5ODBkZDVk');
  return dispatch => {
    fetch(loy3AppLoginUrl, {
      method: 'POST',
      body: formData,
    }).then(v => v.json())
      .then(r => {
        if (r.error === 0) {
          localStorage.setItem('_loy3User', JSON.stringify(r.responseObj));
          dispatch(success(r.responseObj));
          successCallback(r.responseObj.token);
        } else {
          failureCallback();
          dispatch(failure({
            message: r.message,
            type: r.responseObj.type,
            id: r.responseObj.loyaltyMemberId
          }));
        }
      }).catch(err => {

        console.log('Loy3 App Login Request failed', err);
        dispatch(failure(err.message));
      });
  };

  function success(response) {
    return { type: userConstants.LOY3_LOGIN_SUCCESS, authResponse: response }
  }

  function failure(error) {
    return { type: userConstants.LOY3_SSO_LOGIN_FAILURE, error }
  }
}

function loadProfileData(authToken) {
  return dispatch => {
    fetch(`${loy3LoadProfileDataUrl}`, {
      method: 'GET',
      headers: new Headers({
        'Content-type': 'application/json',
        'Accept': 'application/json',
        "X-Auth-Token": authToken
      })
    }).then(v => handleResponse(v)(dispatch))
      .then(r => {
        if (r.error) {
          return Promise.reject(r.message);
        }
        dispatch(success(r.responseObj))
      }).catch(err => {
        console.log('Loy3 load profile data request failed', err);
        dispatch(failure(err.message));
      });
  };

  function success(response) {
    return { type: userConstants.LOY3_LOAD_DATA_SUCCESS, loy3ProfileData: response }
  }

  function failure(error) {
    return { type: userConstants.LOY3_LOAD_DATA_FAILURE, error }
  }
}

function getRegistrationInfo(locale, brandId, authToken) {
  const params = {
    locale: locale || 'en',
  };

  return dispatch => {
    if (!brandId) {
      return Promise.resolve(null);
    }

    // Do not send an empty X-Auth-Token: the backend JWT filter crashes on blank tokens.
    const headers = {};
    if (authToken) {
      headers['X-Auth-Token'] = authToken;
    }

    return fetch(`${registrationInfo}${brandId}?${getQueryString(params)}`, {
      headers: new Headers(headers)
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`Registration lookup failed (${res.status})`);
        }
        return res.json();
      })
      .then(r => {
        const lookupData = r && !r.error ? r.responseObj : null;
        if (!lookupData) {
          throw new Error((r && r.message) || 'Registration lookup returned no data');
        }
        dispatch({ type: userConstants.GET_REGISTRATION_INFO, registrationInfo: lookupData })
        return lookupData;
      })
      .catch(err => {
        console.error('getRegistrationInfo failed', err);
        return Promise.reject(err);
      });
  }
}

function resendEmail(id) {
  return dispatch => {
    fetch(`${resendEmailUrl}` + id)
      .then(res => res.json())
      .then(r => {
      }).catch(err => {
        console.log('Resend email failed', err);
        dispatch(failure(err.message));
      });

    // function success(response) {
    //   return { type: userConstants.RESEND_EMAIL_SUCCESS, loy3ProfileData: response }
    // }

    function failure(error) {
      return { type: userConstants.RESEND_EMAIL_FAILURE, error }
    }
  }
}


function handleResponse(response) {
  return dispatch => (response.text().then(r => {
    const type = typeof r;
    let data = null;
    try {
      data = (r && type === 'string') && JSON.parse(r);
    } catch(e) {
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout()(dispatch);
        dispatch({
          type: SET_MODAL,
          key: 'login',
          val: true
        });
      }
      const error = data ? data.message : response;
      return Promise.reject(error);
    }
    return data;
  }));
}

export function setInitialModalVisible(initialModalVisible) {
    return  { type: userConstants.INITIAL_MODAL_VISIBLE, initialModalVisible };
}